import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Login from "./components/Login";
import DashboardLayout from "./components/DashboardLayout";
import Home from "./components/Home";
import PostList from "./components/PostList";
import PostForm from "./components/PostForm";
import PostDetail from "./components/PostDetail";
import CategoryList from "./components/CategoryList";
import NotFound from "./components/NotFound";
import BackToTop from "./BackToTop/BackToTop";

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />

          <Route
            path="/"
            element={
              <ProtectedRoute>
                <DashboardLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Home />} />

            {/* Posts — single merged listing, filterable by category */}
            <Route path="posts" element={<PostList />} />
            <Route path="posts/create" element={<PostForm mode="create" />} />
            <Route path="posts/edit/:id" element={<PostForm mode="edit" />} />
            <Route path="posts/view/:id" element={<PostDetail />} />

            {/* Categories — managed inline on one page via an overlay form */}
            <Route path="categories" element={<CategoryList />} />

            {/* Legacy links some bookmarks might still point at */}
            <Route path="category/*" element={<Navigate to="/posts" replace />} />
            <Route path="categories/*" element={<Navigate to="/categories" replace />} />
          </Route>

          <Route path="*" element={<NotFound />} />
        </Routes>
        <BackToTop />
      </BrowserRouter>
    </AuthProvider>
  );
}
